import React from "react";

const SPA = "https://images.unsplash.com/photo-1668672355709-a2f199a65201?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcGElMjBpbnRlcmlvciUyMGNhbG18ZW58MHx8fHwxNzc5MDY5NjgxfDA&ixlib=rb-4.1.0&q=85";

const pillars = [
  {
    no: "I.",
    title: "Begin with stillness",
    body: "Therapy starts with creating space — the breath of room you need to actually hear yourself again.",
  },
  {
    no: "II.",
    title: "Evidence, gently held",
    body: "CBT, ACT, EMDR, IFS — the modern science of healing, delivered with old-soul care.",
  },
  {
    no: "III.",
    title: "Move at your pace",
    body: "No prescribed timeline, no performance. Progress that respects your nervous system.",
  },
];

export default function Approach() {
  return (
    <section id="approach" className="relative py-24 md:py-32 bg-[#F4F1EA]" data-testid="approach-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-16 items-start">
        <div className="md:col-span-5 md:sticky md:top-32">
          <p className="overline text-[#9F5C45] mb-6">02 — Our approach</p>
          <h2 className="font-serif font-light text-[#1C1917] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-8">
            What if healing didn’t feel like <em className="italic text-[#3A5A40]">work?</em>
          </h2>
          <p className="text-[#57534E] text-base md:text-lg leading-relaxed mb-10">
            Let Go Wellness was founded on a simple belief: people heal in rooms
            where they feel deeply safe. Everything we’ve built — from the slow
            morning light in our clinic to the way we screen our clinicians — is
            in service of that one feeling.
          </p>
          <div className="relative overflow-hidden">
            <img src={SPA} alt="Clinic interior" className="w-full h-72 md:h-96 object-cover" />
          </div>
        </div>

        <div className="md:col-span-6 md:col-start-7 space-y-12 md:space-y-16">
          {pillars.map((p) => (
            <div key={p.no} data-testid={`pillar-${p.no.replace(".", "")}`} className="border-t border-[#E2DCD0] pt-8">
              <div className="flex items-baseline gap-6 mb-4">
                <span className="font-serif italic text-2xl text-[#9F5C45]">{p.no}</span>
                <h3 className="font-serif text-3xl md:text-4xl text-[#1C1917] leading-tight">
                  {p.title}
                </h3>
              </div>
              <p className="text-[#57534E] text-base md:text-lg leading-relaxed md:pl-12">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
